import React from 'react';

import { useIntlDictionary } from 'hooks/useIntlDictionary';
import { TableTr, TableTd } from 'design/table';
import { PartnerClientsTableItem } from 'types/partnerClientsTable';
import { TextComponent } from 'design/text/textComponents';

type Props = {
  item: PartnerClientsTableItem;
  active: boolean;
  onClick(item: PartnerClientsTableItem): void;
};

export const PartnerCancelledClientsTableRow = (props: Props) => {
  const { item, active, onClick } = props;

  const { partnerClientsTable: ownDictionary } = useIntlDictionary();

  const onRowClick = React.useCallback(() => {
    onClick(item);
  }, [onClick, item]);

  return (
    <TableTr active={active} onClick={onRowClick}>
      <TableTd text={item.organization} />
      <TableTd text={ownDictionary.contactFullNameText(item)} />
      <TableTd text={item.position} />
      <TableTd text={item.phone} />
      <TableTd
        text={item.orgSize ? ownDictionary.orgSizeValue(item.orgSize) : '-'}
      />
      <TableTd text={`${item.licensesCount}`} />
      <TableTd
        text={
          <TextComponent color="critical" size="s">
            {ownDictionary.subscribtionStatusValue(item)}
          </TextComponent>
        }
      />
      <TableTd
        text={
          <TextComponent color="critical" size="s">
            {ownDictionary.willBeDeletedInDaysText(item.willBeDeletedInDays)}
          </TextComponent>
        }
      />
    </TableTr>
  );
};
